/* mf-video — la copertina diventa iframe solo al clic.
   Stessa logica di mf-link.js ma su un gancio proprio, perche questa sezione
   vive dentro il tema normale e non nel layout nudo del link-in-bio. */
(function () {
  document.querySelectorAll('[data-mf-video]').forEach(function (frame) {
    var play = frame.querySelector('.mf-vid-play');
    var poster = frame.querySelector('.mf-vid-poster');
    if (!play) return;

    play.addEventListener('click', function () {
      var f = document.createElement('iframe');
      f.src =
        'https://www.youtube-nocookie.com/embed/' +
        frame.dataset.vid +
        '?autoplay=1&rel=0&modestbranding=1&hl=' +
        frame.dataset.lang;
      f.title = play.getAttribute('aria-label');
      f.allow = 'accelerometer; autoplay; encrypted-media; picture-in-picture; web-share';
      f.allowFullscreen = true;
      frame.appendChild(f);
      play.hidden = true;
      if (poster) poster.hidden = true;
    });
  });
})();
